import * as React from 'react';
export var UnitCourseListContext = React.createContext([]);
export var UnitCourseListProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), unitCourseList = _b[0], setUnitCourseList = _b[1];
    var value = [unitCourseList, setUnitCourseList];
    return React.createElement(UnitCourseListContext.Provider, { value: value }, children);
};
